import { useDeviceDetectorContext } from '../../../../device-detector'
import { useExpaContext } from '../../../../expa'
import { useFirstImpressionContext } from '../../../../first-impression'

export const useProductCrossSellFirstImpressionWidget = (): boolean => {
  const expa = useExpaContext()
  const firstImpression = useFirstImpressionContext()
  const { isMobile } = useDeviceDetectorContext()

  // https://jira.shop-apotheke.com/browse/CRO-576
  return firstImpression && expa === 'gglp' && !isMobile
}
